
import { defineComponent, onMounted, ref } from 'vue';
import { useGtag } from 'vue-gtag-next';

export default defineComponent({
    name: 'AlbertaHeader',
    setup() {
        const { pageview } = useGtag();

        const allServicesIsExpanded = ref<boolean>(false);
        const toggleMenuIsExpanded = ref<boolean>(false);
        const toggleSearchIsExpanded = ref<boolean>(false);

        const allServicesClick = () => {
            toggleSearchIsExpanded.value = false;
            toggleMenuIsExpanded.value = false;
            allServicesIsExpanded.value = !allServicesIsExpanded.value;
        };

        const allServicesMobileClick = () => {
            toggleSearchIsExpanded.value = false;
            allServicesIsExpanded.value = !allServicesIsExpanded.value;
        };

        const searchClick = () => {
            allServicesIsExpanded.value = false;
            toggleMenuIsExpanded.value = false;
            toggleSearchIsExpanded.value = !toggleSearchIsExpanded.value;
        };

        const menuDropdownClick = () => {
            toggleSearchIsExpanded.value = false;
            allServicesIsExpanded.value = false;
            toggleMenuIsExpanded.value = !toggleMenuIsExpanded.value;
        };

        onMounted(() => {
            pageview({ page_path: window.location.href });
        });

        return {
            allServicesIsExpanded,
            toggleMenuIsExpanded,
            toggleSearchIsExpanded,
            allServicesClick,
            allServicesMobileClick,
            searchClick,
            menuDropdownClick
        };
    }
});
